/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Checkbox,
} from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import { useLongPress } from 'use-long-press';
import { contentActions } from '../../store/content-reducer';
import { storeContext } from '../provider/Provider';


const MobileCard = ({ row, isSelected }) => {
  const [longPressed, setLongPressed] = React.useState(false);
  const [fullView, setFullview] = React.useState(false);
  const [, setModalReviewer] = React.useState('');

  const { state, dispatch } = React.useContext(storeContext);
  const useStyles = makeStyles(() => ({
    mobileCard: {
      background: 'white',
      borderRadius: '16px',
      padding: 15,
      margin: 10,
      border: '3px white solid',
    },
    flexLine: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
    },
    flexLineDefault: {
      display: 'flex',
      alignItems: 'center',
    },
  }));

  const handleCheckBox = (event) => {
    setModalReviewer('');
    dispatch({
      type: contentActions.CONTENT_CHECK_BY_ID,
      payload: {
        id: event.target.name,
        checked: event.target.checked,
      },
    });
  };

  const bind = useLongPress(() => {
    if (row.platform_status === 'Content for Review' || row.platform_status === 'Revised Content for Review' || row.platform_status === 'Topics for Review') {
      setLongPressed(true);
      dispatch({
        type: contentActions.CONTENT_CHECK_BY_ID,
        payload: {
          id: row.id,
          checked: !isSelected,
        },
      });
    }
  });

  const handleClick = () => {
    if (!longPressed) {
      setFullview(!fullView);
    }
    setLongPressed(false);
  };

  const classes = useStyles();
  return (
    <div
      className={classes.mobileCard}
      key={row.id}
      style={isSelected ? { border: '3px #00B4E0 solid' } : { border: '3px white solid' }}
      {...bind}
      onClick={handleClick}
      aria-label="default box"
    >
      {fullView ? (
        <>
          <div className={classes.flexLine} style={{ display: 'flex', flexDirection: 'row', width: '100%'}}>
            <div>
              <Checkbox
                checked={state.content.fullView.checked[row.id.toString()]}
                onChange={handleCheckBox}
                name={row.id.toString()}
                color="primary"
                inputProps={{ 'aria-label': 'checkbox' }}
              />
            </div>
            <div className={classes.flexLine}>
              <div style={{ width: '50%', userSelect: 'none', whiteSpace: 'nowrap' }}>{row.date}</div>
            </div>
          </div>
          <div style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }} />
          <div className={classes.flexLine}>
            <div style={{ width: '20%', userSelect: 'none' }}>H1</div>
            <div style={{ width: '80%', userSelect: 'none' }}>{row.h1}</div>
          </div>
          <div className={classes.flexLine}>
            <div style={{ width: '20%', userSelect: 'none' }}>Url</div>
            <div style={{ width: '80%', userSelect: 'none' }}>
              <a href={row.url} target="_blank" rel="noreferrer">
                {row.url}
              </a>
            </div>
          </div>
          {state.content.fullView.currentStatus !== 'topics_for_review' &&
           state.content.fullView.currentStatus !== 'writing' && 
           state.content.fullView.currentStatus !== 'qa' && (
            <div className={classes.flexLine}>
              <div style={{ width: '20%', userSelect: 'none' }}>Google Doc</div>
              <div style={{ width: '80%', userSelect: 'none' }}>
                {row.google_doc_url ? (
                  <a
                    href={`${row.google_doc_url}&email=${state.auth.user.email}${state.auth.user.alternateEmail ? `&email=${state.auth.user.alternateEmail}` : ''}`}
                    style={{ cursor: 'pointer', color: '#2A5CA9' }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Open Content Page &gt;&gt;
                  </a>
                ) : (
                  <p
                    style={{
                      cursor: 'not-allowed',
                      color: '#2A5CA9',
                      textDecoration: 'underline',
                    }}
                  >
                    No Content Document
                  </p>
                )}
              </div>
            </div>
          )}
          <div className={classes.flexLine}>
            <div style={{ width: '20%', userSelect: 'none' }}>Content Type</div>
            <div style={{ width: '80%', userSelect: 'none' }}>{row.content_type}</div>
          </div>
        </>
      ) : (
        <div className={classes.flexLineDefault}>
          <div className={classes.flexLine}>
            <Checkbox
              checked={state.content.fullView.checked[row.id.toString()]}
              onChange={handleCheckBox}
              name={row.id.toString()}
              color="primary"
              inputProps={{ 'aria-label': 'checkbox' }}
            />
          </div>
          <div style={{ width: '20%' }}>{row.date}</div>
          <div style={{ width: '80%', marginLeft: '5px' }}>{row.h1}</div>
        </div>
      )}
    </div>
  );
};

export default MobileCard;
